import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "zoom-levels-editor" }
const _hoisted_2 = { class: "view-tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "device-settings" }
const _hoisted_5 = {
  class: "preview-options",
  ref: "deviceControlsElement"
}
const _hoisted_6 = {
  class: "device-tabs",
  "aria-label": "Buyer layout preview"
}
const _hoisted_7 = {
  key: 0,
  class: "stage-picker"
}
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "preview-stage" }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["viewBox"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["d"]
const _hoisted_14 = ["transform"]
const _hoisted_15 = ["x", "y", "width", "height", "href"]
const _hoisted_16 = ["x", "y", "font-size"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = ["d"]
const _hoisted_19 = ["transform"]
const _hoisted_20 = ["x", "y", "font-size"]
const _hoisted_21 = { key: 2 }
const _hoisted_22 = ["d"]
const _hoisted_23 = ["points"]
const _hoisted_24 = ["x", "y", "width", "height"]
const _hoisted_25 = ["x", "y", "font-size"]
const _hoisted_26 = ["d"]
const _hoisted_27 = {
  key: 0,
  class: "preview-empty"
}
const _hoisted_28 = {
  key: 1,
  class: "center-marker",
  "aria-hidden": "true"
}
const _hoisted_29 = { class: "preview-badge" }
const _hoisted_30 = { class: "preview-help" }
const _hoisted_31 = {
  key: 0,
  class: "preview-panel-card"
}
const _hoisted_32 = {
  key: 1,
  class: "preview-panel-card"
}
const _hoisted_33 = { class: "zoom-settings" }
const _hoisted_34 = { class: "section-heading" }
const _hoisted_35 = { class: "zoom-control" }
const _hoisted_36 = ["max", "aria-label"]
const _hoisted_37 = ["value", "max", "aria-label"]
const _hoisted_38 = {
  key: 0,
  class: "validation-message",
  role: "status"
}
const _hoisted_39 = { class: "actions" }
const _hoisted_40 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "editor-header" }, [
      _createElementVNode("h2", null, "Set Default Zoom Levels"),
      _createElementVNode("p", null, "Set the starting zoom and position for each view and device.")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.views, (view) => {
        return _createElementVNode("button", {
          class: _normalizeClass(["view-tab", { active: $setup.activeView === view.key }]),
          key: view.key,
          type: "button",
          onClick: ($event: any) => ($setup.activeView = view.key)
        }, [
          _createElementVNode("strong", null, _toDisplayString(view.title), 1),
          _createElementVNode("span", null, _toDisplayString(view.description), 1)
        ], 10, _hoisted_3)
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "section-heading" }, [
        _createElementVNode("h3", null, "Device preview"),
        _createElementVNode("span", null, "Choose a layout to adjust")
      ], -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: _normalizeClass(["device-tab", { active: $setup.deviceMode === 'desktop' }]),
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.changePreviewLayout('desktop')))
          }, "Desktop", 2),
          _createElementVNode("button", {
            class: _normalizeClass(["device-tab", { active: $setup.deviceMode === 'mobile' }]),
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.changePreviewLayout('mobile')))
          }, "Mobile portrait", 2),
          _createElementVNode("button", {
            class: _normalizeClass(["device-tab", { active: $setup.deviceMode === 'landscape' }]),
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.changePreviewLayout('landscape')))
          }, "Mobile landscape", 2)
        ]),
        ($setup.deviceMode !== 'desktop')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "mobile-expansion",
              type: "button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.changePreviewLayout($setup.deviceMode, !$setup.mobileExpanded)))
            }, _toDisplayString($setup.mobileExpanded ? "Show standard map" : "Show expanded map"), 1))
          : _createCommentVNode("", true)
      ], 512),
      _cache[10] || (_cache[10] = _createElementVNode("p", { class: "device-hint" }, "Zoom and position are saved separately for each device.", -1)),
      ($setup.activeView === 'lots' && $setup.stages.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _cache[8] || (_cache[8] = _createElementVNode("label", { for: "zoom-preview-stage" }, "Preview stage", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "zoom-preview-stage",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.selectedStageId) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stages, (stage, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: stage.stageId,
                  value: stage.stageId
                }, _toDisplayString($setup.getStageTitle(stage.stageId, index)), 9, _hoisted_8))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.selectedStageId]
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", {
        class: _normalizeClass(["preview-frame", { mobile: $setup.deviceMode !== 'desktop', landscape: $setup.deviceMode === 'landscape' }]),
        ref: "previewFrameElement",
        style: _normalizeStyle($setup.previewFrameStyle)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["preview", { dragging: $setup.isDragging }]),
          style: _normalizeStyle($setup.previewViewportStyle),
          onPointerdown: $setup.startPan,
          onPointermove: $setup.pan,
          onPointerup: $setup.stopPan,
          onPointercancel: $setup.stopPan,
          onWheel: _withModifiers($setup.zoomWithWheel, ["prevent"])
        }, [
          _createElementVNode("div", {
            class: "preview-content",
            style: _normalizeStyle($setup.previewImageStyle)
          }, [
            ($setup.svgUrl)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: $setup.svgUrl,
                  alt: "Masterplan zoom preview",
                  draggable: false
                }, null, 8, _hoisted_10))
              : _createCommentVNode("", true),
            ($setup.svgUrl)
              ? (_openBlock(), _createElementBlock("svg", {
                  key: 1,
                  class: "preview-overlay",
                  viewBox: $setup.viewBoxString,
                  preserveAspectRatio: "xMidYMid meet",
                  "aria-hidden": "true"
                }, [
                  ($setup.activeView === 'estateBoundary' && $props.estateBoundaryPath)
                    ? (_openBlock(), _createElementBlock("g", _hoisted_12, [
                        _createElementVNode("path", {
                          class: "preview-estate-boundary",
                          d: $props.estateBoundaryPath
                        }, null, 8, _hoisted_13),
                        _createElementVNode("g", { transform: $setup.estateLabelTransform }, [
                          ($props.estateLabelMetadata?.logoUrl)
                            ? (_openBlock(), _createElementBlock("image", {
                                key: 0,
                                x: $setup.estateLabelCenter.x - $setup.estateLogoWidth / 2,
                                y: $setup.estateLabelCenter.y - $setup.estateLogoHeight / 2,
                                width: $setup.estateLogoWidth,
                                height: $setup.estateLogoHeight,
                                href: $props.estateLabelMetadata.logoUrl,
                                preserveAspectRatio: "xMidYMid meet"
                              }, null, 8, _hoisted_15))
                            : _createCommentVNode("", true),
                          (!$props.estateLabelMetadata?.logoUrl)
                            ? (_openBlock(), _createElementBlock("text", {
                                key: 1,
                                class: "preview-estate-label",
                                x: $setup.estateLabelCenter.x,
                                y: $setup.estateLabelCenter.y,
                                "text-anchor": "middle",
                                "dominant-baseline": "middle",
                                "font-size": $setup.previewEstateFontSize
                              }, _toDisplayString($props.estateLabelMetadata?.labelText || $props.estateName), 9, _hoisted_16))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_14)
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.activeView === 'stages')
                    ? (_openBlock(), _createElementBlock("g", _hoisted_17, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stages, (stage, index) => {
                          return (_openBlock(), _createElementBlock("g", {
                            key: stage.stageId
                          }, [
                            (stage.boundaryPath)
                              ? (_openBlock(), _createElementBlock("path", {
                                  key: 0,
                                  class: "preview-stage-boundary",
                                  d: stage.boundaryPath
                                }, null, 8, _hoisted_18))
                              : _createCommentVNode("", true),
                            (stage.boundaryPath && $setup.isStageLabelVisible(stage.stageId))
                              ? (_openBlock(), _createElementBlock("g", {
                                  key: 1,
                                  transform: $setup.getStageLabelTransform(stage)
                                }, [
                                  _createElementVNode("text", {
                                    class: "preview-stage-label",
                                    x: $setup.getStageLabelCenter(stage).x,
                                    y: $setup.getStageLabelCenter(stage).y,
                                    "text-anchor": "middle",
                                    "dominant-baseline": "middle",
                                    "font-size": $setup.previewStageFontSize
                                  }, _toDisplayString($setup.getStageTitle(stage.stageId, index)), 9, _hoisted_20)
                                ], 8, _hoisted_19))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.activeView === 'lots')
                    ? (_openBlock(), _createElementBlock("g", _hoisted_21, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.previewLots, (lot) => {
                          return (_openBlock(), _createElementBlock("g", {
                            key: lot.lotId
                          }, [
                            (lot.shapePath)
                              ? (_openBlock(), _createElementBlock("path", {
                                  key: 0,
                                  class: "preview-lot-boundary",
                                  d: lot.shapePath
                                }, null, 8, _hoisted_22))
                              : (lot.polygonPoints?.length)
                                ? (_openBlock(), _createElementBlock("polygon", {
                                    key: 1,
                                    class: "preview-lot-boundary",
                                    points: $setup.getPolygonPoints(lot)
                                  }, null, 8, _hoisted_23))
                                : (lot.boundingBox)
                                  ? (_openBlock(), _createElementBlock("rect", {
                                      key: 2,
                                      class: "preview-lot-boundary",
                                      x: lot.boundingBox.x,
                                      y: lot.boundingBox.y,
                                      width: lot.boundingBox.width,
                                      height: lot.boundingBox.height
                                    }, null, 8, _hoisted_24))
                                  : _createCommentVNode("", true),
                            ($setup.getLotCenter(lot))
                              ? (_openBlock(), _createElementBlock("text", {
                                  key: 3,
                                  class: "preview-lot-label",
                                  x: $setup.getLotCenter(lot)?.x,
                                  y: $setup.getLotCenter(lot)?.y,
                                  "text-anchor": "middle",
                                  "dominant-baseline": "middle",
                                  "font-size": $setup.previewLotFontSize
                                }, _toDisplayString($setup.getLotTitle(lot.lotId)), 9, _hoisted_25))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stages, (stage) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: stage.stageId
                          }, [
                            (stage.boundaryPath)
                              ? (_openBlock(), _createElementBlock("path", {
                                  key: 0,
                                  class: "preview-stage-guide",
                                  d: stage.boundaryPath
                                }, null, 8, _hoisted_26))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_11))
              : _createCommentVNode("", true)
          ], 4),
          (!$setup.svgUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, "Preview unavailable"))
            : _createCommentVNode("", true),
          ($setup.activeView !== 'lots')
            ? (_openBlock(), _createElementBlock("div", _hoisted_28))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_29, _toDisplayString($setup.activeViewLabel) + " · " + _toDisplayString($setup.displayedZoom.toFixed(2)) + "×", 1),
          _createElementVNode("button", {
            class: "reset-view",
            type: "button",
            onPointerdown: _withModifiers(($event: any) => (void 0), ["stop"]),
            onClick: _withModifiers($setup.resetPosition, ["stop"])
          }, "Reset position", 32),
          _createElementVNode("div", _hoisted_30, _toDisplayString($setup.previewHelpText), 1)
        ], 38),
        ($setup.deviceMode === 'desktop' || !$setup.mobileExpanded)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "preview-side-panel",
              style: _normalizeStyle($setup.previewPanelStyle)
            }, [
              _createElementVNode("strong", null, _toDisplayString($setup.activeView === "lots" ? $setup.getStageTitle($setup.selectedStageId, 0) : "Available Lots"), 1),
              ($setup.activeView !== 'lots')
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString($setup.stages.length) + " " + _toDisplayString($setup.stages.length === 1 ? "stage" : "stages"), 1))
                : _createCommentVNode("", true),
              ($setup.activeView === 'lots')
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString($setup.visibleLots.length) + " " + _toDisplayString($setup.visibleLots.length === 1 ? "lot" : "lots"), 1))
                : _createCommentVNode("", true)
            ], 4))
          : _createCommentVNode("", true)
      ], 6)
    ]),
    _cache[13] || (_cache[13] = _createElementVNode("p", { class: "device-hint" }, "1× is the minimum zoom that fills the map in this layout.", -1)),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("h3", null, _toDisplayString($setup.activeViewLabel) + " zoom", 1),
        _createElementVNode("span", null, _toDisplayString($setup.deviceMode === "desktop" ? "Desktop" : $setup.deviceMode === "mobile" ? "Mobile portrait" : "Mobile landscape"), 1)
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("button", {
          class: "zoom-button",
          type: "button",
          onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.changeZoom(-0.1)))
        }, "−"),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.displayedZoom) = $event)),
          type: "range",
          min: "1",
          max: $setup.zoomControlMax,
          step: "0.1",
          "aria-label": `${$setup.activeViewLabel} zoom level`
        }, null, 8, _hoisted_36), [
          [
            _vModelText,
            $setup.displayedZoom,
            void 0,
            { number: true }
          ]
        ]),
        _createElementVNode("button", {
          class: "zoom-button",
          type: "button",
          onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.changeZoom(0.1)))
        }, "+"),
        _createElementVNode("input", {
          class: "zoom-value",
          value: $setup.displayedZoom,
          onChange: $setup.updateZoomInput,
          type: "number",
          min: "1",
          max: $setup.zoomControlMax,
          step: "0.1",
          "aria-label": `${$setup.activeViewLabel} zoom value`
        }, null, 40, _hoisted_37)
      ])
    ]),
    (!$setup.hasValidZoomOrder)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
          _cache[11] || (_cache[11] = _createElementVNode("strong", null, "Check your zoom settings", -1)),
          _createElementVNode("span", null, _toDisplayString($setup.zoomValidationMessage), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("button", {
        class: "btn-primary",
        type: "button",
        disabled: !$setup.hasValidZoomOrder,
        onClick: $setup.complete
      }, "Continue to Points of Interest", 8, _hoisted_40)
    ])
  ]))
}